var map = {
	"./monitor/catalogo/catalogo.module": [
		"./src/app/monitor/catalogo/catalogo.module.ts",
		"default~monitor-catalogo-catalogo-module~monitor-detalle-detalle-module~monitor-ficha-empresa-ficha-~54e03e69",
		"default~monitor-catalogo-catalogo-module~monitor-detalle-detalle-module~monitor-obras-obras-module",
		"common",
		"monitor-catalogo-catalogo-module"
	],
	"./monitor/detalle/detalle.module": [
		"./src/app/monitor/detalle/detalle.module.ts",
		"default~monitor-catalogo-catalogo-module~monitor-detalle-detalle-module~monitor-ficha-empresa-ficha-~54e03e69",
		"default~monitor-catalogo-catalogo-module~monitor-detalle-detalle-module~monitor-obras-obras-module",
		"common",
		"monitor-detalle-detalle-module"
	],
	"./monitor/ficha-empresa/ficha-empresa.module": [
		"./src/app/monitor/ficha-empresa/ficha-empresa.module.ts",
		"default~monitor-catalogo-catalogo-module~monitor-detalle-detalle-module~monitor-ficha-empresa-ficha-~54e03e69",
		"common",
		"monitor-ficha-empresa-ficha-empresa-module"
	],
	"./monitor/obras/obras.module": [
		"./src/app/monitor/obras/obras.module.ts",
		"default~monitor-catalogo-catalogo-module~monitor-detalle-detalle-module~monitor-ficha-empresa-ficha-~54e03e69",
		"default~monitor-catalogo-catalogo-module~monitor-detalle-detalle-module~monitor-obras-obras-module",
		"common",
		"monitor-obras-obras-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;